import axios from "./axios"; // Use default import properly

class PPIService {
  minKycGenerateOtp = async (name, mobile, email) => {
    try {
      const response = await axios.post("/ppi/min_kyc/generate_otp", {
        name,
        mobile,
        email,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  minKycVerifyOtp = async (otp, verification_token) => {
    try {
      const response = await axios.post("/ppi/min_kyc/verify_otp", {
        otp,
        verification_token,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  verifyMinKycDocument = async (
    verification_token,
    document_type,
    name_on_document,
    document_number,
    dob,
    issue_date,
    state
  ) => {
    try {
      const response = await axios.post(
        "/ppi/min_kyc/verify_min_kyc_document",
        {
          verification_token,
          document_type,
          name_on_document,
          document_number,
          dob,
          issue_date,
          state,
        }
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  issueInstantDigitalCard = async () => {
    try {
      const response = await axios.post(
        "/ppi/card/issue_instant_digital_card",
        {}
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getCardDetails = async () => {
    try {
      const response = await axios.post("/ppi/card/get_card_details", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getCardBalance = async () => {
    try {
      const response = await axios.post("/ppi/card/get_balance", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  cardReload = async (amount) => {
    try {
      const response = await axios.post("/ppi/card/reload", { amount });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  cardReloadStatus = async (order_id) => {
    try {
      const response = await axios.post("/ppi/card/reload_status", {
        order_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getPPIUserStatus = async () => {
    try {
      const response = await axios.post("/ppi/ppi_user_status", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getPlatformFees = async () => {
    try {
      const response = await axios.post("/ppi/full_kyc/get_platform_fees", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  initiatePlatformFeesPayment = async () => {
    try {
      const response = await axios.post(
        "/ppi/full_kyc/initiate_fees_payment",
        {}
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  initiateFullKyc = async () => {
    try {
      const response = await axios.post("/ppi/full_kyc/initiate_full_kyc", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  cardStatusUpdate = async (card_status) => {
    try {
      const response = await axios.post("/ppi/card/status_update", {
        card_status,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  cardLimitUpdate = async (
    is_ecomm_transaction_enabled,
    ecomm_transaction_limit
  ) => {
    try {
      const response = await axios.post("/ppi/card/limit_update", {
        is_ecomm_transaction_enabled,
        ecomm_transaction_limit,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  cardTransactionHistory = async () => {
    try {
      const response = await axios.post("/ppi/card/transaction_history", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getPPILimit = async () => {
    try {
      const response = await axios.post("/ppi/ppi_limit/get", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  updatePPILimit = async (
    daily_limit_count,
    daily_limit_amount,
    monthly_limit_count,
    monthly_limit_amount
  ) => {
    try {
      const response = await axios.post("/ppi/ppi_limit/update", {
        daily_limit_count,
        daily_limit_amount,
        monthly_limit_count,
        monthly_limit_amount,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new PPIService();
